import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function updateConfigCompany (data = {}) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      const data = mock.getLocations
      const clone = JSON.parse(JSON.stringify(data))
      resolve(clone)
    })
  } else {
    const req = {
      url: '/api/cifempresas/actualizarconfiguracioncif',
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      data,
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { updateConfigCompany }
